export interface ProjectInfo {
  name: string;
  path: string;
  lastOpened: number;
}

const RECENT_KEY = 'recentProjects';

export const getRecentProjects = (): ProjectInfo[] => {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    return raw ? JSON.parse(raw) as ProjectInfo[] : [];
  } catch (err) {
    console.error('Failed to parse recentProjects from localStorage', err);
    return [];
  }
};

export const addProjectToRecent = (path: string): void => {
  const segments = path.split(/[\\/]/);
  const name = segments[segments.length - 1] || 'project';
  const newProject: ProjectInfo = { name, path, lastOpened: Date.now() };

  const prev = getRecentProjects();
  const updated = [
    newProject,
    ...prev.filter(p => p.path !== path)
  ].slice(0, 10);

  localStorage.setItem(RECENT_KEY, JSON.stringify(updated));
};

export const clearRecentProjects = (): void => {
  localStorage.removeItem(RECENT_KEY);
};